/**
 * nextSunday - Returns the start of next week (Sunday) from any given date
 *
 * Extracted from client VariantForm.tsx (lines 69-72)
 * Calculates the start of the following Sunday from today's date.
 * Used for setting default availability dates for product variants.
 *
 * @returns Date object representing the start of next Sunday
 */

import { addDays, startOfDay, startOfWeek } from "date-fns";

export function nextSunday(): Date {
  const today = startOfDay(new Date());
  return startOfWeek(addDays(today, 7));
}
